import React from "react";
import Slide from "@material-ui/core/Slide";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import "./style/styles.scss";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

export default function Timeline(props) {
  var HtmlToReactParser = require('html-to-react').Parser;
  var htmlToReactParser = new HtmlToReactParser();

  // return (
  //   <div style={{ color: '#333' }}>
  //     <div className="intro-timeline-bar"></div>
  //     <div className="intro-timeline-timeline" id="timeline-new-scrollbar">
  //       {props.timeline && props.timeline.map(story => {
  //         return(
  //           <div className="intro-timeline-entry" id="yourDivID">
  //             <h1 style={{ fontFamily: 'nepali-font' }}>{story.date}</h1>
  //             <h2>{htmlToReactParser.parse(story.description)}</h2>
  //           </div>
  //         )
  //       })}
  //     </div>
  //   </div>
  // );

  return(
    <VerticalTimeline>
    {props.timeline && props.timeline.map(story => {
            return(
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'white', color: '#333' }}
                contentArrowStyle={{ borderRight: '7px solid white' }}
                date=<div style={{ fontFamily: 'nepali-font' }}>{story.date}</div>
                style={{ marginTop: '-40px' }}
                iconStyle={{ background: 'rgb(19, 76, 122)', color: '#fff', backgroundColor: 'rgb(19, 76, 122)', width: '20px', height: '20px', left: '50%', marginLeft: '-10px', marginTop: '20px' }}
              >
                {/*<h3 className="vertical-timeline-element-title">{story.date}</h3>*/}
                {/*<h4 className="vertical-timeline-element-subtitle">Miami, FL</h4>*/}
                <p style={{ marginTop:'0px' }} >
                  {story.image && <img src={story.image} style={{ float: 'left', marginBottom: '10px', backgroundColor: '#999',  border: '4px solid #666'  }} width='100%'/>}
                  {story.story}
                </p>
              </VerticalTimelineElement>
            )
          })}
    </VerticalTimeline>
  )
}
